export function rate_calculator() {


  // //#* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *#
  // //#    Ort und Straße leeren, wenn neue PLZ eingegeben wird     #
  // //#_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _#


  $('#zip').on('input', function(e) {
    $('#town').val('');
    $('#town_id').val('');
    $('#street').val('');
    $('#street_id').val('');

    $('#street_group').addClass("d-none");
    $('#warning_zip').addClass("d-none");
    $('.submit_button').prop('disabled', true);

    $('#town').prop('disabled', true);
    if ($('#zip').val().length > 1) {
      $('#town').attr('placeholder', 'Bitte wählen Sie eine PLZ aus der Liste');
    }
  });


  // //#* * * * * * * * * * * *#
  // //#    ZIP Autocomplete   #
  // //#_ _ _ _ _ _ _ _ _ _ _ _#


  $('#input_zip .typeahead_zip').typeahead({
    minLength: 2,
    dynamic: true,
    cancelButton: false,
    source: {
      ajax: {
        type: "GET",
        url: window.location.pathname.replace('neu','towns'),
        data: {
          search_term: '{{query}}'
        }
      }
    },
    display: 'zip',

    template: function (query, data) {
        const town = setTown(data.town, data.district);
        return '<strong>' + data.zip + '</strong> ' + town;
    },


    emptyTemplate: function (query) {
        if (query.length > 0) {
          'Keine Ergebnisse gefunden für "' + query + '"';
        }

        if (query.length === 5) {
          $('#warning_zip').removeClass("d-none");
        }
    },
    callback: {
        onClickAfter: function (node, a, data, event) {

          event.preventDefault();

          const town = setTown(data.town, data.district);

          $('#input_town .typeahead_town').val(town);
          $('#town_id').val(data.id);
          if (data.further_search === 2) {
            $('#street_group').removeClass("d-none");
          }
          if (data.further_search === 3) {
            $('#street_group').removeClass("d-none");
          }
          console.log(data.further_search)
          if ((data.further_search === 0) || (data.further_search === 1)) {
            return $('.submit_button').prop('disabled', false);
          }


        },
    }
  });

  var setTown = function(town, district) {
    if ((district !== '') && (district !== null)) {
      town += ' - ' + district;
    }
    return town;

  };


  // //#* * * * * * * * * * * *#
  // //#    TOWN Autocomplete   #
  // //#_ _ _ _ _ _ _ _ _ _ _ _#

  $('#input_town .typeahead_town').typeahead({
    minLength: 3,
    dynamic: true,
    cancelButton: false,
    debug: true,
    source: {
      ajax: {
        type: "GET",
        url: window.location.pathname.replace('neu','districts'),
        data: {
          search_term: '{{query}}',
          search_zip: function () { return $('.typeahead_zip').val(); }
        }
      }
    },

    display: 'town',
    templateValue: "{{town}} {{district}}",

    template: function (query, data) {
        const town = setTown(data.town, data.district);
        return '<p>' + town + '</p>';
    },


    emptyTemplate: function (query) {
        if (query.length > 0) {
          return 'Keine Ergebnisse gefunden für "' + query + '"';
        }
    },
    callback: {
        onClickAfter: function (node, a, data, event) {

          event.preventDefault();

          $('#town_id').val(data.id);
          if ((data.further_search === 0) || (data.further_search === 1)) {
            $('.submit_button').prop('disabled', false);
          }

        },
    }
  });




  // $('#input_town .typeahead_town').typeahead({
  //   minLength: 2,
  //   hint: false
  // }, {
  //   source(query, syncResults, asyncResults) {
  //     $.get('/tarifrechner/districts/'+query+'/'+$('#input_zip .typeahead_zip').val(), function(data) {
  //       asyncResults(data);
  //     });
  //   },
  //   display(item) {
  //     const town = setTown(item.town, item.district);
  //     return town;
  //   },

  //   templates: {
  //     empty(context) {
  //       return $('.tt-dataset').html('<p>Zu Ihrem Suchbegriff wurden kein Ort gefunden</p>');
  //     },

  //     suggestion(data) {

  //       let str;
  //       const town = setTown(data.town, data.district);
  //       return str = '<p>' + town + '</p>';
  //     }
  //   }
  // }
  // );

  // $('#input_town .typeahead_town').on('typeahead:selected', function(e, data) {

  //   $('#town_id').val(data.id);
  //   if ((data.further_search === 0) || (data.further_search === 1)) {
  //     return $('.submit_button').prop('disabled', false);
  //   }
  // });




  // //#* * * * * * * * * * * *#
  // //#    STREET Autocomplete   #
  // //#_ _ _ _ _ _ _ _ _ _ _ _#

  $('#input_street .typeahead_street').typeahead({
    minLength: 2,
    dynamic: true,
    cancelButton: false,
    source: {
      ajax: {
        type: "GET",
        url: window.location.pathname.replace('neu','streets'),
        data: {
          search_term: '{{query}}',
          search_zip: function () { return $('.typeahead_zip').val(); }
        }
      }
    },

    display: 'street',

    templates: {
      suggestion: function(data) {
        return '<p><strong>' + data.street + '</strong></p>';
      }
    },


    emptyTemplate: function (query) {
        if (query.length > 0) {
          return 'Keine Ergebnisse gefunden für "' + query + '"';
        }
    },
    callback: {
        onClickAfter: function (node, a, data, event) {

          event.preventDefault();

          $('#street_id').val(data.id);
          return $('.submit_button').prop('disabled', false);

        },
    }
  });


  // $('#input_street .typeahead_street').typeahead({
  //   minLength: 2,
  //   hint: false
  // }, {
  //   source(query, syncResults, asyncResults) {
  //     $.get('/tarifrechner/streets/'+query.replace(/\./g, '')+'/'+$('#input_zip .typeahead_zip').val(), function(data) {
  //       asyncResults(data);
  //     });
  //   },
  //   display: 'street',

  //   templates: {
  //     empty: [
  //       '<p>',
  //       'Zu Ihrem Suchbegriff wurden keine Straße gefunden',
  //       '</p>'
  //     ].join('\n'),

  //     suggestion(data) {
  //       let str;
  //       return str = '<p>' + data.street + '</p>';
  //     }
  //   }
  // }
  // );

  // $('#input_street .typeahead_street').on('typeahead:selected', function(e, data) {

  //   $('#street_id').val(data.id);
  //   // if data.further_search == 3
  //   //   $('#house_no').prop 'required', true
  //   return $('.submit_button').prop('disabled', false);
  // });

}